export default {

  doHospitalAverage (data, query, numeratorField, denominatorField, hospitalId, useMulti) {
    var years = []
    var hist = []
    var hist1a = []
    var hist1b = []
    var hist2 = []

    if (useMulti) {
      numeratorField += (query.organMode === 'multi' ? '_multi' : '_single')
      denominatorField += (query.organMode === 'multi' ? '_multi' : '_single')
    }

    data.forEach(function (item) {
      if (item.donor_hospital === hospitalId) {
        years.push(item.year)
        hist.push(item[numeratorField] / item[denominatorField])
        hist1a.push(item[numeratorField + '_1a'] / item[denominatorField + '_1a'])
        hist1b.push(item[numeratorField + '_1b'] / item[denominatorField + '_1b'])
        hist2.push(item[numeratorField + '_2'] / item[denominatorField + '_2'])
      }
    })

    return { years, hist, hist1a, hist1b, hist2 }
  },

  h_stat_11 (data, query, hospitalId) {
    return this.doHospitalAverage(data, query, 'unused_organs', 'available_organs', hospitalId, false)
  },

  h_stat_12 (data, query, hospitalId) {
    return this.doHospitalAverage(data, query, 'declined_quality_organs', 'available_organs', hospitalId, false)
  }

}



// WEBPACK FOOTER //
// ./src/api/hospital.js